module.exports = __webpack_public_path__ + "static/bank-66c2a2163d71cfb9339d9cc2c43276c7.png";